import LifetimeValueByMembershipModule from "./LifetimeValueByMembershipModule";
import LifetimeValueByMembershipSagas from "./redux/lifetimeValueByMembershipsSagas";
import LifetimeValueByMembershipReducers from "./redux/lifetimeValueByMembershipsReducer";

export default {
  Component: LifetimeValueByMembershipModule,
  moduleName: "lifetimeValueByMembership",
  saga: LifetimeValueByMembershipSagas(),
  reducer: LifetimeValueByMembershipReducers
};
